import * as React from "react";
import apiClients from "../../apiClients";
import { ttlOneMinCaching } from "../../constants/uiConstants";
import { parseId } from "../../helpers/idHelper";
import { OciResourceType, optimizedRetryOption } from "../../helpers/resourceHelper";
import { useQueryCall } from "../../hooks/useQueryCall";
import { AzureSubscriptionSummaryExt } from "../../hooks/useSubscriptions";
import { getOciRegion } from "../../utils";
import { OciLink, OciLinkProps } from "./OciLink";

export interface OciMdsLinkProps extends Pick<OciLinkProps, "location" | "analytics"> {
  resourceId: string;
  subscriptions: AzureSubscriptionSummaryExt[];
}

export const OciMdsLink = ({ resourceId, location, subscriptions, analytics }: OciMdsLinkProps): JSX.Element => {
  const idComps = parseId(resourceId);
  const resGroup = decodeURIComponent(idComps?.resourceGroup || "");
  const resourceName = decodeURIComponent(idComps?.resourceName || "");
  const subscription = subscriptions?.find(item => item.id === idComps?.subscriptionId);

  const { response, error } = useQueryCall({
    wait: !resourceId,
    method: apiClients.withRegion(getOciRegion(location)).mdsDatabaseApi.getMdsDbSystem,
    options: {
      args: {
        subscriptionId: idComps?.subscriptionId || "",
        resourceGroupName: resGroup,
        dbSystemName: resourceName,
      },
      caching: ttlOneMinCaching,
      retry: optimizedRetryOption,
    },
  });

  const mds = response?.data;

  const ociResourcePath = `/mysqlaas/db-systems/${mds?.ocid}`;

  return (
    <OciLink
      ociResourceType={OciResourceType.MDS}
      ociResourcePath={!error && mds?.ocid ? ociResourcePath : undefined}
      ociResourceName={resourceName}
      location={location}
      subscription={subscription}
      analytics={analytics}
    />
  );
};
